import { render, staticRenderFns } from "./DemandItemList.vue?vue&type=template&id=09297d36&scoped=true"
import script from "./DemandItemList.vue?vue&type=script&lang=js"
export * from "./DemandItemList.vue?vue&type=script&lang=js"
import style0 from "./DemandItemList.vue?vue&type=style&index=0&id=09297d36&prod&scoped=true&lang=css"
import style1 from "./DemandItemList.vue?vue&type=style&index=1&id=09297d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09297d36",
  null
  
)

export default component.exports